import type { PropsWithChildren, ReactNode } from "react";
import { tv } from "tailwind-variants";

import { icons } from "@/ui";

const authenticationScreenContainerVariants = tv({
  slots: {
    background:
      "flex min-h-dvh items-center justify-center bg-gradient px-4 py-10 sm:px-6 sm:py-16",
    container: "flex w-full max-w-md flex-col items-center gap-8",
    card: "w-full rounded-card border border-line bg-surface p-6 shadow-card sm:p-10",
    footer: "flex w-full flex-col items-center gap-4 text-content-secondary",
  },
  variants: {
    animate: {
      true: {
        container: "animate-fade-in",
      },
    },
  },
});

const { background, card, container, footer } = authenticationScreenContainerVariants();

type AuthenticationScreenContainerProps = {
  className?: string;
  containerClassName?: string;
  animate?: boolean;
  footer?: ReactNode;
};

export const AuthenticationScreenContainer = ({
  animate = false,
  children,
  className,
  containerClassName,
  footer: footerContent,
}: PropsWithChildren<AuthenticationScreenContainerProps>) => {
  return (
    <div className={background()}>
      <div className={container({ animate, className: containerClassName })}>
        <icons.EOCareIcon className="w-14 text-content sm:w-16" />

        <div className={card({ className })}>{children}</div>

        {footerContent ? <div className={footer()}>{footerContent}</div> : null}
      </div>
    </div>
  );
};
